import { memo } from 'react';
import AddMapDataModal from '../panels/AddMapDataModal/AddMapDataModal';

/**
 * Controller to handle add_map_data action:
 * Renders dedicated AddMapDataModal whenever `action=add_map_data&map_data_id=:id` is present in URL.
 */
const MapDataActionController = () => {
  return <AddMapDataModal />;
};

export default memo(MapDataActionController);
